var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00003 11.4199C9.00003 10.8427 9.20274 10.3665 9.60814 9.99136C10.0135 9.61617 10.5406 9.42859 11.1892 9.42859C11.8263 9.42859 12.3417 9.61328 12.7356 9.9827C13.141 10.3637 13.3437 10.86 13.3437 11.4719C13.3437 12.026 13.1468 12.4877 12.7529 12.8572C12.3475 13.2381 11.8147 13.4286 11.1545 13.4286H11.1371C10.5 13.4286 9.98459 13.2381 9.59076 12.8572C9.19694 12.4762 9.00003 11.9971 9.00003 11.4199ZM9.2259 26.5714V15.0043H13.083V26.5714H9.2259ZM15.2201 26.5714H19.0773V20.1126C19.0773 19.7085 19.1236 19.3968 19.2162 19.1775C19.3784 18.785 19.6245 18.4531 19.9547 18.1818C20.2848 17.9105 20.6989 17.7749 21.1969 17.7749C22.4942 17.7749 23.1429 18.6465 23.1429 20.3896V26.5714H27V19.9394C27 18.2309 26.5946 16.9351 25.7838 16.052C24.973 15.1688 23.9016 14.7273 22.5695 14.7273C21.0753 14.7273 19.9112 15.368 19.0773 16.6494V16.684H19.0599L19.0773 16.6494V15.0043H15.2201C15.2433 15.3737 15.2549 16.5224 15.2549 18.4502C15.2549 20.3781 15.2433 23.0851 15.2201 26.5714Z",
    fill: "#2F2F30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.f4d1e64bc69f471f0a68635faa75bfde.svg";
export { ForwardRef as ReactComponent };